import { Search,  Edit } from "@mui/icons-material";
import { Button, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, InputWithLabel, } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, FormActions,usuarioEntity } from "../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../components/form/ModalForm";




const schema = yup.object({
  comprador: yup.object().shape({
    label:yup.string(),
    value:yup.number()
  }).test("is_selected",(value,ctx)=>{
       
    if ( !value.value  ){
     return  ctx.createError({ message: 'Debe seleccionar un comprador' })
    }
     return true;
 }),
  cod_erp: yup.string().required(),
  comprador_padre:  yup.object().shape({
    label:yup.string(),
    value:yup.number()
  }).nullable().notRequired(),

}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestrosGerarquiaCompradores = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [compradores,setCompradores] = useState([]);
  const [compradoresPadre,setCompradoresPadre] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
 
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    

    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/listar-gerarquia",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{

      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      product.comprador = {
        label:product.nombre_comprador,
        value:product.cod_usuario
      }
      if( product.cod_comprador_padre ){
          product.comprador_padre = {
            label:product.nombre_comprador_padre,
            value:product.cod_comprador_padre
          }
      }else{
        product.comprador_padre = null;
      }
    
   
      setProductoSeleccionado(product);
    
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
     
    }

    const onOpenModalItem = (edit=false)=>{
      console.log({edit});
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      const urlService = typeAction === FormActions.AGREGAR?'maestros/registrar-gerarquia-comprador':'maestros/editar-gerarquia-comprador/'+dataForm.cod;
 
        let payload =  {
          cod_usuario:dataForm.comprador.value,
          cod_erp:dataForm.cod_erp,
          cod_comprador_padre:dataForm.comprador_padre?.value,
         
        };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.put(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        }).catch(err=>{


          if ( err.response?.status === 400 ){
            console.log("error",err.message);
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Advertencia",
                  message:err.response.data.msg,
                  type:DialogType.informativo,
                  isVisible:true
              }
          });
            return;
          }

          console.log("error",err.message);
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
         
   
      
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    const onSearchComprador = async (evt,value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-compradores-filter", {
            search_query: value_search
          });
          setCompradores(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }
    const onSearchCompradorPadre = async (evt,value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/filtrar-comprador-padre", {
            search_query: value_search
          });
          setCompradoresPadre(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }
    const searchCpAsociado = async (event, newInputValue) => {
      await loadCentrosOp(newInputValue.toLowerCase());
     
    }

  
    const columnsTable = [
      {
      
       key:"cod_erp",
       keyValue:"cod_erp",
       label:"Codigo ERP",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"comprador",
        keyValue:"nombre_comprador",
        label:"Comprador",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_comprador_padre",
        keyValue:"nombre_comprador_padre",
        label:"Comprador padre",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },

        {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar comprador":'Modificar comprador',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key: "comprador",
          keyValue: "comprador",
          label: "Comprador",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            name: 'comprador',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchComprador,
            options: compradores || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
        {
          key:"cod_erp",
          keyValue:"cod_erp",
          label:"Codigo ERP del comprador",
          component:InputWithLabel,
          inputProps:{
            type:"text"
          }
        },
     
        {
          key: "comprador_padre",
          keyValue: "comprador_padre",
          label: "Comprador padre",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            name: 'comprador_padre',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchCompradorPadre,
            options: compradoresPadre || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
       
      ],
      arrayInputs:[]
    } ;

    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar comprador"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo comprador</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}